import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ClientsComponent } from "./clients/clients.component";
import { ConfigMediasComponent } from "./config-medias/config-medias.component";
import { RolesControllerComponent } from "./roles-controller/roles-controller.component";
import { PermissionsControllerComponent } from "./permissions-controller/permissions-controller.component";
import { ProfileComponent } from "./profile/profile.component";
import { DesignReelsComponent } from "./design-reels/design-reels.component";
const routes: Routes = [
	{
		path: "",
		redirectTo: "clientes",
		pathMatch: "full",
	},
	{
		path: "clientes",
		component: ClientsComponent,
		data: {
			title: "Clientes",
		},
	},
	{
		path: "categorias",
		component: ConfigMediasComponent,
		data: {
			title: "Categorias",
		},
	},
	{
		path: "perfil", // client/config/perfil
		component: ProfileComponent,
		data: {
			title: "Perfil",
		},
	},
	{
		path: "roles",
		component: RolesControllerComponent,
		data: {
			title: "Roles",
		},
	},
	{
		path: "design-reels",
		component: DesignReelsComponent,
		data: {
			title: "Roles",
		},
	},
	{
		path: "design-reels/:id",
		component: DesignReelsComponent,
		data: {
			title: "Campañas",
		},
	},
	{
		path: "permisos",
		component: PermissionsControllerComponent,
		data: {
			title: "Permisos",
		},
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ConfigurationsRoutingModule {}
